import { Button } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';
import { COMMON_LOGIN_MODAL } from '@spotahome/marketplace-common/src/channels';

import './EmptyFavorites.scss';

const handleModalOpen = () => {
  Mediator.publish(COMMON_LOGIN_MODAL, {
    initialAction: 'signup',
    events: {
      open: {
        eventCategory: 'signup/login modal',
        eventAction: 'Favourites',
        eventLabel: 'open'
      },
      close: {
        eventCategory: 'signup/login modal',
        eventAction: 'Favourites',
        eventLabel: 'close'
      }
    }
  });
};

const EMPTY_FAVORITES_IMAGE =
  'https://static.spotahome.com/images/login_favorites.svg';

const EmptyFavoritesLogged = () => (
  <div className="empty-favorites" id="no-results">
    <img
      className="empty-favorites__image"
      src={EMPTY_FAVORITES_IMAGE}
      alt={trans('favorites.message.sign_up')}
    />
    <p className="empty-favorites__text">
      {trans('favorites.message.will_appear.not_logged')}
    </p>
    <div className="empty-favorites__button-container">
      <Button
        alt
        className="empty-favorites__back-to-search ga-favorites-page-back-button"
        href="/"
      >
        {trans('favorites.message.continue_searching')}
      </Button>
      <Button
        className="empty-favorites__new-account ga-favorites-page-account-button"
        onClick={handleModalOpen}
      >
        {trans('favorites.message.sign_up')}
      </Button>
    </div>
  </div>
);

export default EmptyFavoritesLogged;
